import { Device, between, from } from '@helpers/media';
import styled from 'styled-components';
const Video = styled.video `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  &[data-mobile='true'] {
    @media ${from(Device.Tablet)} {
      display: none;
    }
  }

  &[data-tablet='true'] {
    display: none;

    @media ${between(Device.Tablet, Device.TabletLarge)} {
      display: block;
    }
  }

  &[data-desktop='true'] {
    display: none;

    @media ${from(Device.TabletLarge)} {
      display: block;
    }
  }
`;
const VideoBannerStyles = {
    Video,
};
export default VideoBannerStyles;
